module.exports = __webpack_public_path__ + "img/login-vencedoresdetarqui.37863475.svg";